import React, {useState} from "react";
import {useParams} from "react-router-dom";

// global components
import {NAVIGATION_BAR_HEIGHT} from "../../../../designSystem/tokens/spacing";
import {Divider} from "../../../../designSystem/components/Divider";
import {ActionButton} from "../../../../designSystem/components/ActionButton";
import {Dialog} from "../../../../designSystem/components/Dialog";

// shared components
import {FormPageLayout} from "../../../../components/layout/FormPageLayout";
import {ShortAnswer} from "../../../../components/ShortAnswer";
import {BsrsForm} from "../../../bsrs/components/BsrsForm";
import {BsrsFormResultView} from "../../../bsrs/components/BsrsFormResultView";
import {NextStepButton} from "../../../../widgets/NextStepButton";

import {NotQualifyDialog} from "../NotQualifyDialog";
import {ApplicationFormTitle} from "../ApplicationFormTitle";

import {useNewApplicationStep1} from "../../hooks/useNewApplicationStep1";
import {MODAL_CONTENT} from "../../model/modalContent";
import {generateDefaultFormData} from "../../model/generateDefaultFormData";
import {CheckboxForm} from "../CheckboxForm";

enum MODE {
  VIEW = 'view',
  FORM = 'form',
}

export const NewApplicationMobilePsychologist = () => {
  const [mode, setMode] = useState<MODE>(MODE.FORM);
  const {category} = useParams();
  const [formData, setFormData] = useState(generateDefaultFormData(category))
  const { dialogContent, checkboxes, submit, onConfirm, disQualifyReason } = useNewApplicationStep1({ category, formData })

  const handleSubmit = () => {
    if (mode === MODE.FORM) {
      setMode(MODE.VIEW);
    } else {
      submit();
    }
  }

  return (
    <React.Fragment>
      <FormPageLayout
        height={NAVIGATION_BAR_HEIGHT.LARGE}
        body={
          mode === MODE.FORM ? (
            <div className={"flex flex-col gap-4 p-6 "}>
              <ApplicationFormTitle category={category} />
              <Divider />

              <CheckboxForm
                checkboxes={checkboxes}
                formData={formData}
                onChange={(value) => setFormData(value)}
              />

              <ShortAnswer
                className="flex-1"
                label="請提供個案心理困擾描述："
                value={formData.distressDescription}
                onChange={(e) => {
                  setFormData({ ...formData, distressDescription: e.target.value })
                }}
              />
              <BsrsForm onChangeAnswer={(answer, score) => {
                setFormData({
                  ...formData,
                  BSRSScore: score,
                  BSRSAnswer: answer,
                })
              }} />
            </div>
          ) : (
            <div className="flex flex-col gap-y-4 p-4">
              <BsrsFormResultView
                score={formData.BSRSScore}
                answers={formData.BSRSAnswer}
              />
              <ActionButton
                onClick={() => setMode(MODE.FORM)}
                label="重新填寫"
                variant="outline"
                iconName="fa-arrows-rotate"
              />
            </div>
          )
        }
        footer={<NextStepButton onClick={handleSubmit} />}
      />
      <Dialog isOpen={dialogContent !== ''}>
        {dialogContent === MODAL_CONTENT.NOT_QUALIFIED ? (
          <NotQualifyDialog disQualifyReason={disQualifyReason} onClick={onConfirm} />
        ) : null}
      </Dialog>
    </React.Fragment>
  )
}

export default NewApplicationMobilePsychologist;
